interface LikeKeyboardEvent {
  key: string;
  shiftKey: boolean;
}

export const isActionKey = (event: LikeKeyboardEvent) =>
  ['Space', 'Enter', ' '].includes(event.key);

export const isEscapeKey = (event: LikeKeyboardEvent): boolean =>
  ['Esc', 'Escape'].includes(event.key);

export const isUpKey = (event: LikeKeyboardEvent): boolean =>
  ['Up', 'ArrowUp'].includes(event.key);

export const isDownKey = (event: LikeKeyboardEvent): boolean =>
  ['Down', 'ArrowDown'].includes(event.key);

export const isTabPreviousKey = (event: LikeKeyboardEvent) =>
  isTabKey(event) && event.shiftKey;

export const isTabNextKey = (event: LikeKeyboardEvent) =>
  isTabKey(event) && !event.shiftKey;

export const isTabKey = (event: LikeKeyboardEvent) => event.key === 'Tab';
